import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
//
import { Loader, CloseIcon } from 'components';
import { NotesForm } from './NotesForm';
import { DeclineForm } from './DeclineForm';

@connect(({ applicationState: { processing = {} } }) => ({
  processing,
}))
export class RequestModal extends React.PureComponent {
  static propTypes = {
    hideModal: PropTypes.func,
    options: PropTypes.shape({
      onRequest: PropTypes.func,
      titleModal: PropTypes.string,
      notesLabel: PropTypes.string,
      fieldName: PropTypes.string,
      descriptionModal: PropTypes.string,
      isDecline: PropTypes.bool,
      studyType: PropTypes.number,
    }),
  };

  static defaultProps = {
    options: {
      isDecline: false,
      studyType: 1,
    },
  };

  handleSubmit = async (values) => {
    const { options: { onRequest } = {} } = this.props;

    onRequest(values);
  };

  closeModal = () => {
    const { hideModal } = this.props;
    hideModal();
  };

  render() {
    const {
      options: {
        titleModal,
        notesLabel,
        fieldName,
        descriptionModal,
        isDecline,
        studyType,
        buttonText = '',
        placeholderSmall = false,
      } = {},
      hideModal,
    } = this.props;

    return (
      <Loader isShow={this.props.processing}>
        <div
          className="white-box p-15 text-left"
          style={{ width: isDecline ? '800px' : '550px' }}
        >
          <div className="close-icon">
            <CloseIcon width="11px" height="11px" onClick={this.closeModal} />
          </div>
          <div className="montserrat bold fs-16">{titleModal}</div>
          <div
            className="montserrat fs-13 lh-20 mt-1"
            style={{ color: '#6E7780' }}
          >
            {descriptionModal}
          </div>
          {isDecline ? (
            <DeclineForm
              studyType={studyType}
              notesLabel={notesLabel}
              fieldName={fieldName}
              hideModal={hideModal}
              onSubmit={this.handleSubmit}
            />
          ) : (
            <NotesForm
              notesLabel={notesLabel}
              fieldName={fieldName}
              placeholderSmall={placeholderSmall}
              buttonText={buttonText}
              onSubmit={this.handleSubmit}
            />
          )}
        </div>
      </Loader>
    );
  }
}
